import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router'
import { ConnectRestService } from '../services/connect-rest.service';

@Component({
  selector: 'app-sales-assisted-thank-you',
  templateUrl: './sales-assisted-thank-you.component.html',
  styleUrls: ['./sales-assisted-thank-you.component.scss']
})
export class SalesAssistedThankYouComponent implements OnInit {
  DirectorName: any
  URLLink: any
  constructor(
    private activatedRoute: ActivatedRoute,
    private connect: ConnectRestService
  ) { }

  ngOnInit() {
    this.connect.clearSessionStorage()
    this.DirectorName =  this.activatedRoute.snapshot.paramMap.get('name')
  //  this.URLLink =  sessionStorage.Link
  }

}
